import secureLocalStorage from "react-secure-storage";

import * as api from "middlewares/apis";

import { addNewContact } from "actions/contacts";
import { fetchingDataFromApi, buildingComponent, updatingData } from "actions/loaders";
import { setCurrentSelectedAccount } from "actions/appPreferences";

import { GET_ACCOUNT_INFO_BY_ID, GET_ALL_ACCOUNTS_OF_USER } from "helpers/constants";
import {
	findInObjectArrayByMatchingProperties,
	removeItemFromObjectArrayByMatchingProperties,
	replaceItemInObjectArrayByMatchingProperties,
} from "helpers/functions";
import dexieDB from "database/dexieDB";
import { encryptUint8Array } from "middlewares/cryptoJs";

// Action Creators
export const getAllAccountsByUser = (accountSortby) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	dispatch(buildingComponent(true));

	try {
		if (currentUser?.loginType === "daffi") {
			// let userAccounts = secureLocalStorage.getItem(currentUser?._id + "-T-Accounts");
			// if (userAccounts?.accounts) {
			// 	dispatch({
			// 		type: GET_ALL_ACCOUNTS_OF_USER,
			// 		payload: userAccounts["accounts"],
			// 	});
			// 	await api.getAllAccountsByUser(accountSortby, currentUser["access-token"]).then(({ data }) => {
			// 		if (data) {
			// 			secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data);
			// 		}
			// 	});
			// } else {
			// 	await api.getAllAccountsByUser(accountSortby, currentUser["access-token"]).then(({ data }) => {
			// 		if (data) {
			// 			secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data);
			// 			dispatch({
			// 				type: GET_ALL_ACCOUNTS_OF_USER,
			// 				payload: data["accounts"],
			// 			});
			// 		}
			// 	});
			// }
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data?.data) {
						return data.data;
					} else return null;
				});

			dispatch({
				type: GET_ALL_ACCOUNTS_OF_USER,
				payload: userData,
			});
		}
	} catch (error) {
		console.error(error);
	}

	dispatch(buildingComponent(false));
};

export const getAccountInfoById = (accountID, baseCurrency, algoChain) => async (dispatch) => {
	dispatch(fetchingDataFromApi(true));

	try {
		const { data } = await api.getAccountInfoById(accountID, baseCurrency, algoChain);

		await dispatch({
			type: GET_ACCOUNT_INFO_BY_ID,
			payload: data["account"],
		});
	} catch (error) {
		if (error?.response?.data?.code === 404) {
			dispatch({
				type: GET_ACCOUNT_INFO_BY_ID,
				payload: {
					...error?.response?.data,
					"account-address": accountID,
				},
			});
		}
	}

	dispatch(fetchingDataFromApi(false));
};

export const checkAccountAvailabilityInUserProfile = async (formData) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const matchedAccounts = await findInObjectArrayByMatchingProperties(userData.data, {
					"account-address": formData["account-address"],
				});

				if (matchedAccounts?.length) return false;
				else return true;
			} else return true;
		}
	} catch (error) {
		console.error(error);
	}
};

export const getAccountNameByAccountID = async (accountID) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	if (accountID) {
		try {
			if (currentUser?.loginType === "daffi") {
				// const token = secureLocalStorage.getItem("token");
				// const { data } = await api.updateAccountInfoByID(formData, token);
				// if (data && data["data"]) {
				// 	alert(data["message"]);
				// 	secureLocalStorage.setItem("accounts", data["data"]);
				// } else {
				// 	alert(data["message"]);
				// }
				// dispatch({ type: GET_ALL_ACCOUNTS_OF_USER });
				// dispatch(buildingComponent(false));
			} else if (currentUser?.loginType === "local") {
				const userData = await dexieDB.tAlgoAccounts
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data) {
							return data;
						} else return null;
					});

				if (userData?.data) {
					const matchedAccounts = await findInObjectArrayByMatchingProperties(userData?.data, {
						"account-address": accountID,
					});

					if (matchedAccounts?.[0]?.name) return matchedAccounts[0].name;
					else return null;
				} else return null;
			}
		} catch (error) {
			console.error(error);
		}
	} else {
		console.log("missing parameter accountID");
	}
};

export const addNewAccountInUserProfile = (formData, navigatePage, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		dispatch(updatingData(true));

		if (currentUser?.loginType === "daffi") {
			// await api.addNewAccountInUserProfile(formData, currentUser["access-token"]).then(async ({ data }) => {
			// 	if (data && data["data"]) {
			// 		secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data["data"]);
			// 		let userAccounts = secureLocalStorage.getItem(currentUser?._id + "-T-Accounts");
			// 		dispatch(setCurrentSelectedAccount(formData["account-address"]));
			// 		dispatch({
			// 			type: GET_ALL_ACCOUNTS_OF_USER,
			// 			payload: userAccounts["accounts"],
			// 		});
			// 		navigatePage("/");
			// 	} else if (data && data["error"]) {
			// 		alert(data["message"]);
			// 	}
			// });
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const accounts = findInObjectArrayByMatchingProperties(userData.data, {
					"account-address": formData["account-address"],
				});

				if (accounts?.length) {
					notify("error", "Account is already imported");
				} else {
					userData.data.push({
						...formData,
						"notification-preferences": {
							"device-notification": { send: true, receive: true },
							"email-notification": { send: false, receive: false },
						},
					});

					await dexieDB.tAlgoAccounts.update(userData.id, { data: userData.data }).then((updateCount) => {
						if (updateCount) notify("success", "Account added successfully");
						else notify("error", "Account add failed");
					});
				}
			} else {
				await dexieDB.tAlgoAccounts
					.add({
						userID: currentUser?._id,
						data: [
							{
								...formData,
								"notification-preferences": {
									"device-notification": { send: true, receive: true },
									"email-notification": { send: false, receive: false },
								},
							},
						],
					})
					.then((id) => {
						if (id) notify("success", "Account added successfully");
						else notify("error", "Account add failed");
					});
			}

			dispatch(
				addNewContact(
					{
						"friendly-name": formData?.name,
						"account-address": formData?.["account-address"],
						"profile-image": formData?.["profile-image"],
					},
					notify
				)
			);

			dispatch(setCurrentSelectedAccount(formData["account-address"]));

			dispatch({
				type: GET_ALL_ACCOUNTS_OF_USER,
				payload: userData?.data ? userData.data : [formData],
			});

			navigatePage("/");
		}

		dispatch(updatingData(false));
	} catch (error) {
		console.error(error);
	}
};

export const addNewAccountSecretKeyForUser = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		dispatch(updatingData(true));

		formData["secret-key"] = await encryptUint8Array(formData["secret-key"]);

		const userData = await dexieDB.tAlgoSecretKeys
			.filter((item) => item?.userID === currentUser?._id)
			.first()
			.then((data) => {
				if (data) {
					return data;
				} else return null;
			});

		if (userData?.data) {
			const accounts = findInObjectArrayByMatchingProperties(userData.data, {
				"account-address": formData["account-address"],
			});

			if (accounts?.length) {
				notify("error", "Secret-key is already imported");
			} else {
				userData.data.push(formData);

				await dexieDB.tAlgoSecretKeys.update(userData.id, { data: userData.data }).then((updateCount) => {
					if (updateCount) notify("success", "Secret-key is stored successfully");
					else notify("error", "Secret-key is store failed");
				});
			}
		} else {
			await dexieDB.tAlgoSecretKeys.add({ userID: currentUser?._id, data: [formData] }).then((id) => {
				if (id) notify("success", "Secret-key is stored successfully");
				else notify("error", "Secret-key is store failed");
			});
		}

		dispatch(updatingData(false));
	} catch (error) {
		console.error(error);
	}
};

export const updateAccountInfoByID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		dispatch(buildingComponent(true));

		if (currentUser?.loginType === "daffi") {
			// const token = secureLocalStorage.getItem("token");
			// const { data } = await api.updateAccountInfoByID(formData, token);
			// if (data && data["data"]) {
			// 	alert(data["message"]);
			// 	secureLocalStorage.setItem("accounts", data["data"]);
			// } else {
			// 	alert(data["message"]);
			// }
			// dispatch({ type: GET_ALL_ACCOUNTS_OF_USER });
			// dispatch(buildingComponent(false));
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const contactData = await dexieDB.contacts
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data) {
							return data;
						} else return null;
					});

				if (contactData?.data) {
					const matchedUserContacts = findInObjectArrayByMatchingProperties(contactData?.data, {
						"account-address": formData["account-address"],
					});

					if (matchedUserContacts?.length) {
						const newUserContacts = replaceItemInObjectArrayByMatchingProperties(
							contactData?.data,
							{
								"account-address": matchedUserContacts[0]["account-address"],
							},
							{
								...matchedUserContacts[0],
								"friendly-name": formData["name"],
								"profile-image": formData["profile-image"],
							}
						);

						await dexieDB.contacts.update(contactData.id, { data: newUserContacts }).then((updateCount) => {
							if (!updateCount) notify("error", "Account info update failed");
							// else notify("success", "Account info updated");
						});
					}
				}

				const newUserAccounts = replaceItemInObjectArrayByMatchingProperties(
					userData?.data,
					{
						"account-address": formData["account-address"],
					},
					formData
				);

				await dexieDB.tAlgoAccounts.update(userData.id, { data: newUserAccounts }).then((updateCount) => {
					if (!updateCount) notify("error", "Account info update failed");
					// else notify("success", "Account info updated");
				});
			} else {
				notify("error", "There are no accounts found in user profile");
			}
		}

		dispatch(buildingComponent(false));
	} catch (error) {
		console.error(error);
	}
};

export const updateAccountListSortByUserID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", formData);
			// const { data } = await api.updateAccountListSortByUserID(formData, currentUser["access-token"]);
			// alert("Account sort update::success");
			// if (data && data["message"]) alert(data["message"]);
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				await dexieDB.tAlgoAccounts.update(userData.id, { data: formData }).then((updateCount) => {
					if (updateCount) notify("success", "Account sorting updated");
					else notify("error", "Account sorting failed");
				});
			} else {
				notify("error", "There are no accounts found in user profile");
			}
		}
	} catch (error) {
		console.error(error);
	}
};

export const deleteAccountFromUserProfile = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// await api.deleteAccountFromUserProfile(formData, currentUser["access-token"]).then(async ({ data }) => {
			// 	if (data && data["error"]) {
			// 		alert(data["message"]);
			// 	} else if (data && data["data"]) {
			// 		let userAccounts = secureLocalStorage.getItem(currentUser?._id + "-T-Accounts");
			// 		if (userAccounts && userAccounts["accounts"] && userAccounts["accounts"].length > 0) {
			// 			await removeItemFromObjectArrayByMatchingProperties(userAccounts["accounts"], formData);
			// 			secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data["data"]);
			// 			dispatch({
			// 				type: GET_ALL_ACCOUNTS_OF_USER,
			// 				payload: data["data"]["accounts"],
			// 			});
			// 		} else {
			// 			alert("No accounts found in local database");
			// 		}
			// 		alert(data["message"]);
			// 	}
			// });
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.tAlgoAccounts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const secretKeys = await dexieDB.tAlgoSecretKeys
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data) {
							return data;
						} else return null;
					});

				if (secretKeys?.data) {
					let newSecretKeys = await removeItemFromObjectArrayByMatchingProperties(secretKeys?.data, formData);

					await dexieDB.tAlgoSecretKeys.update(secretKeys.id, { data: newSecretKeys }).then((updateCount) => {
						if (updateCount) notify("success", "Secret-key removed");
						else notify("error", "Secret-key failed to remove");
					});

					let newUserAccounts = await removeItemFromObjectArrayByMatchingProperties(userData?.data, formData);

					await dexieDB.tAlgoAccounts.update(userData.id, { data: newUserAccounts }).then((updateCount) => {
						if (updateCount) notify("success", "Account deleted");
						else notify("error", "Account deletion failed");
					});

					dispatch({
						type: GET_ALL_ACCOUNTS_OF_USER,
						payload: newUserAccounts,
					});
				}
			}
		}
	} catch (error) {
		console.error(error);
	}
};

export const getHelpMeOutQuote = async (algoChain) => {
	// try {
	// 	const { data } = await api.getHelpMeOutQuote(algoChain);
	// 	if (data) return data;
	// } catch (error) {
	// 	console.error(error);
	// }
};

export const getTimestampByAccountID = async (accountID, algoChain) => {
	if (accountID) {
		try {
			const { data } = await api.getTimestampByAccountID(accountID, algoChain);
			return data;
		} catch (error) {
			console.error(error);
		}
	}
};

export const getAccountAmountById = async (accountID, baseCurrency, algoChain) => {
	try {
		const { data } = await api.getAccountAmountById(accountID, baseCurrency, algoChain);

		if (data?.account) return data?.account;
	} catch (error) {
		console.error(error);
	}
};

export const getNFDByAccountID = async (accountID) => {
	if (accountID) {
		try {
			const { data } = await api.getNFDByAccountID(accountID);

			if (data && data.length) {
				return data[0]["name"];
			} else {
				return null;
			}
		} catch (error) {
			console.error(error);
		}
	} else {
		console.log("missing parameter accountID");
	}
};

export const searchAccountIDsByNFD = async (nfd) => {
	if (nfd) {
		try {
			const { data } = await api.searchAccountIDsByNFD(nfd);

			if (data && data.length) {
				return data;
			} else {
				return null;
			}
		} catch (error) {
			console.error(error);
		}
	} else {
		console.log("missing parameter nfd");
	}
};

export const getAccountIDByNFD = async (nfd) => {
	if (nfd) {
		try {
			const { data } = await api.getAccountIDByNFD(nfd);

			if (data) {
				return data;
			} else {
				return null;
			}
		} catch (error) {
			console.error(error);
		}
	} else {
		console.log("missing parameter nfd");
	}
};

export const getAssetInfoFromAccount = async (formData, algoChain) => {
	try {
		const { data } = await api.getAssetInfoFromAccount(formData, algoChain);

		if (data) {
			return data;
		} else {
			return null;
		}
	} catch (error) {
		console.error(error);
	}
};
